export default __webpack_public_path__ + "static/media/p_main_img.ed3a1674.jpg";